import { WebViewerInstance } from '@pdftron/webviewer'

export function zoomToArea(
  instance: WebViewerInstance,
  pageNumber: number,
  x1: number,
  y1: number,
  x2: number,
  y2: number
) {
  const { Core } = instance
  const { documentViewer } = Core

  const viewerHeight = documentViewer.getViewerElement().clientHeight
  const viewerWidth = documentViewer.getViewerElement().clientWidth

  const boxWidth = x2 - x1
  const boxHeight = y2 - y1

  const zoomX = viewerWidth / boxWidth
  const zoomY = viewerHeight / boxHeight

  const newZoom = Math.min(zoomX, zoomY) * 0.8

  documentViewer.zoomTo(newZoom)

  documentViewer.displayPageLocation(pageNumber, x1, y1, false)
}
